import Datepicker from '@vuepic/vue-datepicker';
import Icon from '🔗/components/ui/Icon.vue';

import { vTooltip } from '🔗/utils/directives/tooltip.js'
import vDragScroll from '🔗/utils/directives/drag-scroll';
import vIntersectionObserver from '🔗/utils/directives/intersection-observer';

import axios from 'axios';
import Vue3TouchEvents from "vue3-touch-events";
import { createApp } from 'vue';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import { fetchData, message } from '🔗/utils/utils';
import { createPinia } from 'pinia';

import stores from '@/stores';

import '🔗/assets/scss/base.scss';
import '@/assets/scss/base.scss';
import '@vuepic/vue-datepicker/dist/main.css';

if (import.meta.env.VITE_APP_TITLE) {
    document.title = import.meta.env.VITE_APP_TITLE;
}

export const app = createApp(App);

app.use(router);
router.app = app;

// Pinia
const pinia = createPinia();
pinia.use(({ store }) => {
    store.$http = fetchData;
    store.$message = message;
});

app.use(pinia);
app.use(Vue3TouchEvents, {
    gesture: true // обязательно для pinch и rotate
});
app.use(VueAxios, axios);
app.use(VueCookies);
app.use(stores.locale().create());

app.component('Datepicker', Datepicker);
app.component('Icon', Icon);

app.directive('tooltip', vTooltip);
app.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f);
            }
        };
        window.addEventListener('scroll', f);
    }
});

app.directive('drag-scroll', vDragScroll);
app.directive('intersection-observer', vIntersectionObserver);


app.config.globalProperties.$http = fetchData;
app.config.globalProperties.$message = message;

app.mount('#bilbo-app');
